import { BoxProps, ColorOptions, TextNewProps } from '@jfs/ui-new'

export const FAILED = 'rgba(201, 73, 73, 0.95)' as ColorOptions
export const FAILED_ALPHA = 'rgba(201, 73, 73, 0.1)' as ColorOptions

export const styles = {
  headerTitle: {
    fontSize: 18,
    lineHeight: 24,
    fontFamily: 'jiotype-medium',
    color: 'BLACK_21',
    textAlign: 'left',
  } as TextNewProps,
  boxContainer: {
    ph: 40,
    justifyContent: 'center',
  } as BoxProps,
  failedText: {
    fontSize: 12,
    lineHeight: 20,
    fontFamily: 'jiotype-medium',
    color: FAILED,
    textAlign: 'left',
  } as TextNewProps,
  rowContainer: {
    flexDirection: 'row',
  } as BoxProps,
  failedContainer: {
    ph: 8,
    pv: 2,
    bg: FAILED_ALPHA,
    borderRadius: 4,
  } as BoxProps,
  statusText: {
    fontSize: 12,
    lineHeight: 20,
    fontFamily: 'jiotype-medium',
    textAlign: 'center',
  } as TextNewProps,
  statusBox: {
    ph: 8,
    pv: 1,
    borderRadius: 4,
    alignSelf: 'center',
  } as BoxProps,
  downloadText: {
    fontSize: 12,
    lineHeight: 20,
    fontFamily: 'jiotype-medium',
    textAlign: 'center',
    color: 'BLUE',
  } as TextNewProps,
  downloadBox: {
    alignItems: 'center',
    flexDirection: 'row',
    alignSelf: 'center',
  } as BoxProps,
  downloadTextWhite: {
    fontSize: 12,
    lineHeight: 20,
    fontFamily: 'jiotype-medium',
    textAlign: 'center',
    color: 'WHITE',
  } as TextNewProps,
}
